import React, { useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { productionOrderStates as state } from '../../Config/productionOrderStates'
import Popover from '@material-ui/core/Popover';
import ChangeStatePopoverContent from '../Planning/ChangeStatePopoverContent';
import Timer from '../Shared/Timer';
import { dataService } from '../../Services/data.service'
import StartOrderDialog from '../Shared/Dialogs/StartOrderDialog';
import { toast } from 'react-toastify';
import StopOrderDialog from '../Shared/Dialogs/StopOrderDialog';
import PDFDialog from '../Shared/Dialogs/PDFDialog';
import ApiHelper, * as apiHelper from '../../Helpers/apiHelper';
import { connect } from 'react-redux';
import MessageContent from '../Workstation/MessageContent';

export const OrderDetailSideBar = (props) => {

    const classes = useStyles();
    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = useState(null);
    const [stopOrderDialogOpen, setStopOrderDialogOpen] = useState(false)
    const [startOrderDialogOpen, setStartOrderDialogOpen] = useState(false)
    const [workinstructionsDialogOpen, setWorkinstructionsDialogOpen] = React.useState(false);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let stateIcon = <React.Fragment></React.Fragment>;
    let stateBackgroundColor = ""

    let totalBoxes = props.productionOrder.bomOut[0].quantityToProduce
    let lastBox = false;
    if (props.producedBOMOut) {

        let progress = Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier)
        if (totalBoxes - 1 === progress) {
            lastBox = true
        }
    }

    switch (props.productionOrder.productionOrderStatus) {
        case state.RUNNING:
            stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
            stateBackgroundColor = "rgb(92, 201, 88,0.28)"
            break;
        case state.PAUSED:
            stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
            stateBackgroundColor = "rgb(245, 145, 40,0.28)"
            break;
        case state.STOPPED:
            stateIcon = <div className={classes.stop}></div>;
            stateBackgroundColor = "rgb(216, 73, 73,0.28)"
            break;
        case state.PLANNED:
            stateIcon = <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>;
            stateBackgroundColor = "rgb(2, 1, 0,0.28)"
            break;
        case state.DONE:
            stateIcon = <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>;
            stateBackgroundColor = "rgb(92, 201, 88,0.28)"
            break;
        default:
    }

    const changeOrderState = (status) => {
        //check quantity at machine from each material       
        if (status === state.STOPPED) {
            setAnchorEl(null)
            setDialogTitle(t("Are you sure to stop?"))
            setDialogContext(t("This can not be made undone!"))
            setStopOrderDialogOpen(true)
        }
        else if (status === state.PAUSED) {
            dataService.pauseProductionOrder(props.productionOrder.id).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            setAnchorEl(null)
        }
        else if (status === state.RUNNING) {
            if (props.productionOrder.productionOrderStatus === state.PAUSED) {
                startOrder()
                setAnchorEl(null)
            }
            else {
                setAnchorEl(null)
                setDialogTitle(t("Start a job!"))
                setDialogContext(t("Order " + props.productionOrder.reference))
                setStartOrderDialogOpen(true)
            }
        }
    }

    const startOrder = () => {
        dataService.startProductionOrder(props.productionOrder.id, 1).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        setStartOrderDialogOpen(false)
    }

    const stopOrder = () => {
        dataService.stopProductionOrder(props.productionOrder.id).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        setStopOrderDialogOpen(false)
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const openPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeWorkinstructionsDialog = () => {
        setWorkinstructionsDialogOpen(false)
    }

    const openWorkingInstructionsDialog = () => {
        setWorkinstructionsDialogOpen(true)
    }

    const navigateToYazzoomURL = () => {
        window.open(ApiHelper.appSettings.YAZZOOM_EXTERNAL_URL, "_blank")
    }

    const navigateToSiemensURL = () => {
        window.open(ApiHelper.appSettings.SIEMENS_EXTERNAL_URL, "_blank")
    }

    let pausedOrRunning = props.productionOrder.productionOrderStatus === state.RUNNING || props.productionOrder.productionOrderStatus === state.PAUSED
    let doneOrStopped = props.productionOrder.productionOrderStatus === state.DONE || props.productionOrder.productionOrderStatus === state.STOPPED
    let planned = props.productionOrder.productionOrderStatus === state.PLANNED
    return <React.Fragment>

        <div className={classes.stateContainer} style={{ backgroundColor: stateBackgroundColor }}>
            {(doneOrStopped) ?
                <div className={classes.centerState}>
                    <div className={classes.icon}>{stateIcon}</div>
                    <div className={classes.stateElapsed} >
                        <div className={classes.state} style={{ marginTop: "8px" }}>{t(props.productionOrder.productionOrderStatus)}</div>
                    </div>
                </div> :
                <button className={classes.popoverButton} style={{ cursor: props.rushOrder && pausedOrRunning ? "auto" : "pointer" }} onClick={props.rushOrder && pausedOrRunning? null : openPopover}>
                    <div className={classes.centerState}>
                        <div className={classes.icon}>{stateIcon}</div>
                        <div className={classes.stateElapsed} >
                            <div className={classes.state} style={{ marginTop: planned ? "8px" : "0px" }}>{t(props.productionOrder.productionOrderStatus)}</div>
                            <div className={classes.elapsed}>{pausedOrRunning ? <Timer startTime={props.productionOrder.startedOn} {...props}></Timer> : <React.Fragment></React.Fragment>}</div>
                        </div>
                        {(!props.rushOrder || !pausedOrRunning ) && <ExpandMoreIcon className={classes.expandStatesIcon}></ExpandMoreIcon>}
                    </div>
                </button>}
        </div>
        <div className={classes.actions}>
            {<React.Fragment>
                <div className={classes.action}>
                    <button className={classes.actionButton} onClick={() => navigateToYazzoomURL()}>
                        <div className={classes.actionText}>
                            {'Yanomaly (Yazzoom)'}
                        </div>
                    </button>
                </div>
                <div className={classes.action}>
                    <button className={classes.actionButton} onClick={() => navigateToSiemensURL()}>
                        <div className={classes.actionText}>
                            {'WinCC Unified (Siemens)'}
                        </div>
                    </button>
                </div>
                <div className={classes.action}>
                    <button className={classes.actionButton} onClick={props.pdfReady ? () => openWorkingInstructionsDialog() : null}>
                        <div className={classes.actionText}>
                            {t('WorkInstructions')}
                        </div>
                    </button>
                </div>
            </React.Fragment>}
        </div>
        <div className={classes.notifications}>
            {props.notification.notifications.sort((a, b) => new Date(b.insertedOn) - new Date(a.insertedOn)).slice(0, 3).map(z => <MessageContent message={z} key={z.notificationId} textWidth={"80%"} iconPadding={"8px"} messageHeight={"65px"} backgroundColor={"white"}></MessageContent>)}
        </div>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <ChangeStatePopoverContent rushOrder={props.rushOrder} state={props.productionOrder.productionOrderStatus} changeState={changeOrderState} popoverWidth={"15vw"}></ChangeStatePopoverContent>
        </Popover>
        <PDFDialog {...props} dialogOpen={workinstructionsDialogOpen} closeDialog={closeWorkinstructionsDialog} ></PDFDialog>
        <StopOrderDialog producedBOMOut={props.producedBOMOut} dialogOpen={stopOrderDialogOpen} closeDialog={() => setStopOrderDialogOpen(false)} stopOrder={stopOrder} productionOrder={props.productionOrder} dialogContext={dialogContext} dialogTitle={dialogTitle} ></StopOrderDialog>
        <StartOrderDialog dialogOpen={startOrderDialogOpen} preparation={props.preparation} closeDialog={() => setStartOrderDialogOpen(false)} startOrder={startOrder} productionOrder={props.productionOrder} dialogContext={dialogContext} dialogTitle={dialogTitle} ></StartOrderDialog>
    </React.Fragment>
}

const useStyles = makeStyles({
    play: {
        color: "#5CC958",
        height: "50px",
        width: "50px"
    },
    stop: {
        height: "30px",
        width: "30px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "45px",
        width: "45px",
        color: "#F59127",
        marginLeft: "5px"
    },
    planned: {
        height: "35px",
        width: "35px",
        marginTop: "5px",
        marginRight: "10px"
    },
    done: {
        height: "35px",
        width: "35px",
        marginTop: "5px",
        marginRight: "10px"
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    icon: {
        float: "left",
    },
    state: {
        textTransform: "uppercase",
        fontSize: "17px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block"
    },
    stateElapsed: {
        float: "left",
        marginLeft: "5px",
        marginTop: "5px"
    },
    elapsed: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block"
    },
    stateContainer: {
        width: "100%",
        height: "80px",
        paddingTop: "40px",
        textAlign: "center"
    },
    centerState: {
        height: "40px",
        marginRight: "auto",
        marginLeft: "auto",
        width: "200px"
    },
    changeButton: {
        width: "86%",
        marginTop: "15px",
        marginLeft: "7%",
        marginRight: "7%",
        height: "40px",
        borderRadius: "6px",
        padding: "0px",
        border: "none",
        outline: "none",
        cursor: "pointer",
    },
    changePlay: {
        color: "white",
    },
    changePause: {
        color: "white",
    },
    changeText: {
        color: "white",
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "5px",
        paddingTop: "8px"
    },
    changeArrow: {
        float: "right",
    },
    expandStatesIcon: {
        float: "right",
        marginTop: "10px",
        marginLeft: "10px"
    },
    changeIcon: {
        float: "left",
        padding: "5px",
        paddingRight: "0px"
    },
    changeArrowIcon: {
        paddingTop: "5px",
        paddingRight: "5px",
        height: "25px",
        width: "25px",
        fill: "white"
    },
    newBookingButton: {
        width: "86%",
        marginTop: "20px",
        marginLeft: "7%",
        marginRight: "7%",
        marginBottom: "10px",
        height: "40px",
        borderRadius: "6px",
        padding: "0px",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        border: "none",
        outline: "none",
        cursor: "pointer",
    },
    newBookingText: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        padding: "5px",
    },
    actions: {
        width: "100%",
        height: "auto",
        padding: "7%",
        paddingTop: "20px",
        boxSizing: "border-box"
    },
    action: {
        backgroundColor: "#4654FB22",
        height: "40px",
        widht: "100%",
        borderRadius: "5px",
        marginBottom: "5px",
    },
    actionText: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: FlagstoneTheme.palette.primary.main,
        textTransform: "none",
        width: "100%",
        textAlign: "center"

    },
    actionButton: {
        paddingLeft: "0px",
        width: "100%",
        border: "none",
        outline: "none",
        cursor: "pointer",
        paddingTop: "12px",
        paddingBottom: "7px",
        backgroundColor: "transparent",
    },
    popoverButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "rgba(1,1,1,0)"
    },
    notifications: {
        padding: "10px"
    }


});

function mapStateToProps(state) {
    return {
        notification: state.notification
    }
}

export default connect(mapStateToProps)(OrderDetailSideBar)